import { store } from "../store";
import { logout } from "../store/slices/authSlice";

let logoutInProgress = false;

/**
 * Logs the user out on the server and clears
 * all authentication state on the client.
 */
export const performLogout = async (): Promise<void> => {
  if (logoutInProgress) {
    return;
  }

  logoutInProgress = true;

  try {
    await fetch("/api/auth/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
  } catch (error) {
    console.error("Server logout failed:", error);
  } finally {
    store.dispatch(logout());

    if (window.location.pathname !== "/login") {
      window.location.replace("/login");
    }

    logoutInProgress = false;
  }
};
